module.exports = __webpack_public_path__ + "img/tab3.d2eb503f.png";